import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  alternate?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  alternate = false
}: SectionProps) {
  return <section id={id} className={`
        relative py-12 md:py-20 px-6 md:px-8 overflow-hidden
        ${alternate ? 'bg-cream-dark' : 'bg-cream'}
        ${className}
      `} data-id="element-704">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[400px] h-[300px] bg-sage/[0.03] rounded-full blur-[100px] pointer-events-none" data-id="element-705" />

      {/* Top decorative divider */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brown/[0.06] to-transparent" data-id="element-706" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.8,
      ease: [0.25, 0.1, 0.25, 1]
    }} className="max-w-2xl mx-auto relative z-10" data-id="element-707">
        {children}
      </motion.div>
    </section>;
}